








import LoaderState from '@front-app/components/LoaderState.vue';
import { defineComponent } from '@vue/composition-api';
import BaseGroupPageColumn from './BaseGroupPageColumn.vue';

export default defineComponent({
	components: { BaseGroupPageColumn, LoaderState },
});
